import firebase from "../firebase";

export default function({ officeId, senderId, userId, conversationId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "removeParticipantFromConversation",
        data: { officeId, senderId, userId, conversationId }
    });
}
